import type { ChatMode } from "@repo/shared/types/chat-mode";

import { boardPage$ } from "~/pages/board/board.store";
import { datasetPage$ } from "~/pages/dataset/dataset.store";
import { getRouter } from "~/router";
import { chat$ } from "~/stores/chat";

export interface ChatRequestContext {
  datasetId?: string;
  boardId?: string;
  focusedBlockId?: string;
  chatMode: ChatMode;
}

/** Reads the current page context at send-time (non-reactive). */
export const getChatContext = (): ChatRequestContext => {
  const pathname = getRouter().state.location.pathname;
  const ctx: ChatRequestContext = { chatMode: chat$.mode.get() };

  if (pathname.startsWith("/datasets/")) {
    const id = datasetPage$.activeDatasetId.get();
    if (id) ctx.datasetId = id;
  } else if (pathname.startsWith("/boards/")) {
    const id = boardPage$.activeBoardId.get();
    if (id) ctx.boardId = id;
    const focusedBlockId = boardPage$.selectedBlockId.get();
    if (focusedBlockId) ctx.focusedBlockId = focusedBlockId;
  }

  return ctx;
};
